const FooterNavbar = () => {
  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light bg-white z-index-3 border-bottom-0">
        <div className="container">
         <a href="/HomePage"> <img src="../../assets/img/salarlogo.png" height="100" alt="" /></a>
          <div
            className="collapse navbar-collapse w-100 pt-3 pb-2 py-lg-0"
            id="navigation"
          >
            <ul className="navbar-nav navbar-nav-hover mx-auto">
              <li className="nav-item mx-2">
                <a
                  href="/CorporateInfo"
                  className="nav-link ps-3 d-flex justify-content-between cursor-pointer align-items-center fs-6 fw-bold text-black"
                  role="button"
                >
                  About Us
                </a>
              </li>

              <li className="nav-item mx-2">
                <a
                  href="/EmployeeBenifits"
                  className="nav-link ps-3 d-flex justify-content-between cursor-pointer align-items-center fs-6 fw-bold text-black"
                  role="button"
                >
                  Our Work Place
                </a>
              </li>
              <li className="nav-item mx-2">
                <a
                  href="/WorkWithUs"
                  className="nav-link ps-3 d-flex justify-content-between cursor-pointer align-items-center fs-6 fw-bold text-black"
                  role="button"
                >
                  Career
                </a>
              </li>
              <li className="nav-item mx-2">
                <a
                  href="/Brands"
                  className="nav-link ps-3 d-flex justify-content-between cursor-pointer align-items-center fs-6 fw-bold text-black"
                  role="button"
                >
                  Brands
                </a>
              </li>
              <li className="nav-item mx-2">
                <a
                  href="."
                  className="nav-link ps-3 d-flex justify-content-between cursor-pointer align-items-center fs-6 fw-bold text-black"
                  role="button"
                >
                  Media
                </a>
              </li>
              <li className="nav-item mx-2">
                <a
                  href="/Magzines"
                  className="nav-link ps-3 d-flex justify-content-between cursor-pointer align-items-center fs-6 fw-bold text-black"
                  role="button"
                >
                  Magazines
                </a>
              </li>
              <li className="nav-item mx-2">
                <a
                  href="."
                  className="nav-link ps-3 d-flex justify-content-between cursor-pointer align-items-center fs-6 fw-bold text-black"
                  role="button"
                >
                  Partner Service
                </a>
              </li>
              <li className="nav-item mx-2">
                <a
                  href="."
                  className="nav-link ps-3 d-flex justify-content-between cursor-pointer align-items-center fs-6 fw-bold text-black"
                  role="button"
                >
                  Blogs
                </a>
              </li>
            </ul>

            <ul className="navbar-nav d-lg-block d-none">
              <li className="avatar avatar-sm border rounded-circle border-radius-2xl bg-white me-2">
                <a href=".">
                  <i className="bi bi-whatsapp fs-6 text-black"></i>
                </a>
              </li>
              <li className="avatar avatar-sm border rounded-circle border-radius-2xl bg-white me-2">
                <a href=".">
                  <i className="bi bi-instagram fs-6 text-black"></i>
                </a>
              </li>
              <li className="avatar avatar-sm border rounded-circle border-radius-2xl bg-white me-2">
                <a href=".">
                  <i className="bi bi-facebook fs-6 text-black"></i>
                </a>
              </li>
              <li className="avatar avatar-sm border rounded-circle border-radius-2xl bg-white me-2">
                <a href=".">
                  <i className="bi bi-twitter-x fs-6 text-black"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default FooterNavbar;
